var n1 = 'number';
var n2 = 'number, number';
export function notNumber(x) {
  return !x;
}
notNumber.signature = n1;
export function orNumber(x, y) {
  return !!(x || y);
}
orNumber.signature = n2;
export function xorNumber(x, y) {
  return !!x !== !!y;
}
xorNumber.signature = n2;
export function andNumber(x, y) {
  return !!(x && y);
}
andNumber.signature = n2;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/plain/number/logical.js
// module id = 1993
// module chunks = 0